import React from 'react';

interface Props {
	children: React.ReactNode;
	className?: string;
}

const CustomSettingsTable: React.FC<Props> = ({ children, className }) => {
	return (
		<table className={className}>
			<tbody>{children}</tbody>
		</table>
	);
};

export default CustomSettingsTable;
